import React, { useState } from "react";
import { Parallax } from "react-scroll-parallax";
import { motion, AnimatePresence } from "framer-motion";
import "./Classes.css";
import classesData from "../data/classesData.js";

export default function Classes() {
  const [activeClass, setActiveClass] = useState(null);

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  };

  const openModal = (classItem) => setActiveClass(classItem);
  const closeModal = () => setActiveClass(null);

  // Split classes into two sections
  const mainClasses = classesData.filter((c) =>
    ["two-year-olds", "three-year-olds", "four-year-olds"].includes(c.id)
  );
  const otherPrograms = classesData.filter(
    (c) => !["two-year-olds", "three-year-olds", "four-year-olds"].includes(c.id)
  );

  return (
    <div className="classes-page">
      {/* ===================== */}
      {/* Hero Section */}
      {/* ===================== */}
      <Parallax speed={-10}>
  <section className="classes-hero">
    <div
      className="hero-image"
      style={{
        backgroundImage: `url(${require("../assets/classesBG.webp")})`,
      }}
    >
      
    </div>

    <div className="hero-overlay" />

    <div className="classes-hero-content">
      <h1>Our Classes</h1>
      <p>
        At Binkley, every age group explores, learns, and grows through
        love and play. Click a class to explore!
      </p>
    </div>
  </section>
</Parallax>

      {/* ===================== */}
      {/* Main Classes Grid */}
      {/* ===================== */}
      <motion.div
        className="classes-grid"
        initial="hidden"
        animate="visible"
        variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
      >
        {mainClasses.map((classItem) => (
          <motion.div
            key={classItem.id}
            className="class-card"
            onClick={() => openModal(classItem)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            variants={cardVariants}
          >
            <img
              src={classItem.image}
              loading="lazy"
              alt={`${classItem.title} class`}
            />
            <div className="class-card-text">
              <h2>{classItem.title}</h2>
              <p>{classItem.shortDesc}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>

      {/* ===================== */}
      {/* Other Programs Grid */}
      {/* ===================== */}
      <section className="other-programs">
        <motion.div
          className="classes-grid"
          initial="hidden"
          animate="visible"
          variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
        >
          {otherPrograms.map((program) => (
            <motion.div
              key={program.id}
              className="class-card"
              onClick={() => openModal(program)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              variants={cardVariants}
            >
              <img
                src={program.image}
                loading="lazy"
                alt={`${program.title}`}
              />
              <div className="class-card-text">
                <h2>{program.title}</h2>
                <p>{program.shortDesc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* ===================== */}
      {/* Modal */}
      {/* ===================== */}
      <AnimatePresence>
        {activeClass && (
          <motion.div
            className="modal-overlay fullscreen"
            onClick={closeModal}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className={`modal-content fullscreen-content ${
                activeClass.id === "specials" ? "wide-modal" : ""
              }`}
              onClick={(e) => e.stopPropagation()}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 50 }}
              transition={{ duration: 0.3 }}
            >
              <button className="modal-close" onClick={closeModal}>
                ✕
              </button>

              <div className="modal-layout">
                {/* Image on the left */}
                <div className="modal-image-left">
                  <img
                    src={activeClass.image2 || activeClass.image}
                    alt={activeClass.title}
                  />
                </div>

                {/* Text on the right */}
                <div className="modal-text-right">
                  <h2>{activeClass.title}</h2>

                  {/* If the class has sections (like Specials) */}
                  {activeClass.sections ? (
                    activeClass.sections.map((section, index) => (
                      <div key={index} className="modal-section">
                        <h3>{section.title}</h3>
                        <p>{section.desc}</p>
                      </div>
                    ))
                  ) : (
                    <div className="modal-description">
                      {activeClass.fullDesc}
                    </div>
                  )}

                  {activeClass.sched && (
                    <p className="schedule">{activeClass.sched}</p>
                  )}
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
